import React from "react";
import { useTranslation } from "react-i18next";
import FeatherIcon from "feather-icons-react";

const UnderDevelopment = () => {
    const { t } = useTranslation();

    return (
        <div className="not-found">
            <h2><FeatherIcon icon="tool" size={106} /></h2>
            <h4>{t("Page under development")}</h4>
            <p>{t("This section isn't ready yet. Please check back later.")}</p>
        </div>
    );
};

export default UnderDevelopment;
